import { RichTextComponent, isElement } from '../utils';

// These tags won't be rendered
export const Ignored: RichTextComponent = node =>
  isElement(node) &&
  ['script', 'meta', 'body', 'head', 'style', 'rel', 'html', 'title'].includes(node.name) ? (
    <></>
  ) : null;
